import { request } from '@/api/request';
import type { FileModel } from '@@/packages/shared/types/models/file';

export type FilesResponse = { files: Record<string, FileModel> };

export const fetchUploads = (fileIDs: string[]) =>
  request<FilesResponse>('POST', '/uploads', { fileIDs });
